import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
//api
import { createSchedule } from 'api/company';
//components
import Title from 'components/backoffice/texts/title';
import ScheduleForm from 'components/backoffice/forms/scheduleForm';

const ScheduleCreate = () => {
  const { t } = useTranslation(['backoffice']);
  const fileInputRef = useRef(null);
  const { reset } = useForm()
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {setTitle} = useOutletContext()

  useEffect(()=>{
    setTitle(t('createschedule'))
    return () => {
      setTitle(''); 
    };
  },[setTitle])


  const handleClearFile = (image) => {
    if (image !== undefined) {
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const defaultValues = {
    title: '',
    status: null,
    type_schedule: null,
    start_date: null,
    end_date: null,
    body: '',
    place: '',
    tag_list: [],
    image: undefined
  }

  const onSubmit = useCallback(async (values) => {
    setLoading(true);
    const data = {
      title: values.title,
      status: values.status,
      type_schedule: values.type_schedule,
      start_date: values.start_date,
      end_date: values.end_date,
      body: values.body,
      place: values.place,
      image: values.image,
      tags: values.tags
    };
    try {
      const { status } = await createSchedule(data);
      if (status === 201) {
        toast.success(t('creadocorrectamente'));
        reset()
        handleClearFile(values.image)
        navigate('/intranet/schedules', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, []);

  return (
    <>
      <Title text={t('createschedule')} />
      <ScheduleForm 
        isEditing={false} 
        onSubmitForm={onSubmit} 
        fileInputRef={fileInputRef} 
        defaultValues={defaultValues} 
        beforeTitle={t('createschedule')}
        loading={loading}
      />
    </>
  );
};

export default ScheduleCreate;
